// noinspection DuplicatedCode

import {createAsyncThunk, createSlice,} from "@reduxjs/toolkit";

import axios from "axios";

let user = JSON.parse(localStorage.getItem("user"));

// API


export const getSpecTiket = createAsyncThunk(
    "tiketTransaksi/getSpecTiket",
    async ({TransaksiApprovalID}, thunkAPI) => {
        let formData = new FormData();
        formData.append("TransaksiApprovalID", TransaksiApprovalID);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'getSpecTiket',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const getTiketTransaksi = createAsyncThunk(
    "tiketTransaksi/get",
    async ({start, count, search}, thunkAPI) => {
        let formData = new FormData();
        formData.append("start", start);
        formData.append("count", count);
        formData.append("search", search);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'getTiket',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const getTransaksiCodeTiket = createAsyncThunk(
    "tiketTransaksi/getTransaksiCodeTiket",
    async ({Nik}, thunkAPI) => {
        let formData = new FormData();
        formData.append("Nik", Nik);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'getTransaksiCodeTiket',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const insertTiketTransaksi = createAsyncThunk(
    "tiketTransaksi/insert",
    async ({
               Nik,
               JenisTiket,
               KeperluanTiket,
               JumlahKeberangkatan,
               PergiDari,
               TanggalKeberangakatan,
               NamaArmada,
               PulangDari,
               TanggalPulang,
               Dewasa,
               Anak,
               Bayi,
               DasarPermohonan,
               NomorTransaksi
           }, thunkAPI) => {
        let formData = new FormData();
        formData.append("Nik", Nik);
        formData.append("JenisTiket", JenisTiket);
        formData.append("KeperluanTiket", KeperluanTiket);
        formData.append("JumlahKeberangkatan", JumlahKeberangkatan);
        formData.append("PergiDari", PergiDari);
        formData.append("TanggalKeberangakatan", TanggalKeberangakatan);
        formData.append("NamaArmada", NamaArmada);
        formData.append("PulangDari", PulangDari);
        formData.append("TanggalPulang", TanggalPulang);
        formData.append("Dewasa", Dewasa);
        formData.append("Anak", Anak);
        formData.append("Bayi", Bayi);
        formData.append("DasarPermohonan", DasarPermohonan);
        formData.append("NomorTransaksi", NomorTransaksi);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'insertTiket',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)

export const updateTiketTransaksi = createAsyncThunk(
    "tiketTransaksi/update",
    async ({
               TTiketID,
               Nik,
               JenisTiket,
               KeperluanTiket,
               JumlahKeberangkatan,
               PergiDari,
               TanggalKeberangakatan,
               NamaArmada,
               PulangDari,
               TanggalPulang,
               Dewasa,
               Anak,
               Bayi,
               DasarPermohonan,
               NomorTransaksi,
           }, thunkAPI) => {
        let formData = new FormData();
        formData.append("TTiketID", TTiketID);
        formData.append("Nik", Nik);
        formData.append("JenisTiket", JenisTiket);
        formData.append("KeperluanTiket", KeperluanTiket);
        formData.append("JumlahKeberangkatan", JumlahKeberangkatan);
        formData.append("PergiDari", PergiDari);
        formData.append("TanggalKeberangakatan", TanggalKeberangakatan);
        formData.append("NamaArmada", NamaArmada);
        formData.append("PulangDari", PulangDari);
        formData.append("TanggalPulang", TanggalPulang);
        formData.append("Dewasa", Dewasa);
        formData.append("Anak", Anak);
        formData.append("Bayi", Bayi);
        formData.append("DasarPermohonan", DasarPermohonan);
        formData.append("NomorTransaksi", NomorTransaksi);
        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'updateTiket',
                formData,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)
export const getTiketLaporan = createAsyncThunk(
    "getTiketLaporan/post",
    async (obj, thunkAPI) => {

        try {
            const response = await axios.post(
                process.env.REACT_APP_API_URL+'hrd/tiket/lap',
                obj,
                {
                    headers: {
                        'Authorization': "Bearer " + user.Token,
                        "Accept": "*/*",
                    }
                }
            )
            if (response.status === 200) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data);
            }
        } catch (e) {
            thunkAPI.rejectWithValue(e.response.data);
        }
    }
)
export const resetTiketSlice = createAsyncThunk(
    "resetTiketSlice/update",
    async ({}, thunkAPI) => {
        return true
    }
)
//INIT
const initialState = {
    message: "",
    SpecTiketData: [],
    isSpecTiketFetching: false,
    isSpecTiketSuccess: false,
    isSpecTiketError: false,
    isGetFetching: false,
    isGetSuccess: false,
    isGetError: false,
    isInsertFetching: false,
    isInsertSuccess: false,
    isInsertError: false,
    isUpdateFetching: false,
    isUpdateSuccess: false,
    isUpdateError: false,
    errorMessage: "",
    report: [],
    reportDetail: null,
    isGetReport: false
};


//SLICES
export const tiketTransaksiSlice = createSlice({
    name: "tiketTransaksi",
    initialState,
    reducers: {},
    extraReducers: {
        // GET
        [getTiketLaporan.fulfilled]: (state, {payload}) => {
            state.report = payload.data;
            state.message = payload.message;
            state.isGetReport = true;
            return state;
        },
        [getTiketLaporan.rejected]: (state, {payload}) => {
            state.isSpecTiketFetching = false;
        },
        [getTiketLaporan.pending]: (state) => {
            state.isSpecTiketFetching = false;
        },

        [getSpecTiket.fulfilled]: (state, {payload}) => {
            state.SpecTiketData = payload.data[0];
            state.isSpecTiketSuccess = true;
            state.message = payload.message;
            return state;
        },
        [getSpecTiket.rejected]: (state, {payload}) => {
            state.isSpecTiketFetching = false;
        },
        [getSpecTiket.pending]: (state) => {
            state.isSpecTiketFetching = false;
        },

        [getTiketTransaksi.fulfilled]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetSuccess = true;
            state.data = payload.data;
            state.count = payload.count;
            state.message = payload.message;
            return state;
        },
        [getTiketTransaksi.rejected]: (state, {payload}) => {
            state.isGetFetching = false;
            state.isGetError = true;
            state.errorMessage = payload.message;
        },
        [getTiketTransaksi.pending]: (state) => {
            state.isGetFetching = true;
        },

        [getTransaksiCodeTiket.fulfilled]: (state, {payload}) => {
            state.isGetTransaksiCodeTiketFetching = false;
            state.isGetTransaksiCodeTiketSuccess = true;
            state.dataTransaksiCodeTiket = payload.data;
            return state;
        },
        [getTransaksiCodeTiket.rejected]: (state, {payload}) => {
            state.isGetTransaksiCodeTiketFetching = false;
            state.isGetTransaksiCodeTiketError = true;
        },
        [getTransaksiCodeTiket.pending]: (state) => {
            state.isGetTransaksiCodeTiketFetching = true;
        },

        // INSERT
        [insertTiketTransaksi.fulfilled]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [insertTiketTransaksi.rejected]: (state, {payload}) => {
            state.isInsertFetching = false;
            state.isInsertError = true;
            state.errorMessage = payload.message;
        },
        [insertTiketTransaksi.pending]: (state) => {
            state.isInsertFetching = true;
        },

        // UPDATE
        [updateTiketTransaksi.fulfilled]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateSuccess = true;
            state.message = payload.message;
            window.location.reload(false);
            return state;
        },
        [updateTiketTransaksi.rejected]: (state, {payload}) => {
            state.isUpdateFetching = false;
            state.isUpdateError = true;
            state.errorMessage = payload.message;
        },
        [updateTiketTransaksi.pending]: (state) => {
            state.isUpdateFetching = true;
        },
    },
});


export const tiketTransaksiSelector = (state) => state.tiketTransaksi;
